<template>
  <div class="home">
    <header-view curr="1"></header-view>
    <div class="body">
      <div class="boxtitle">
        <titleview title="捐助项目" color="#E61F26" class="left"></titleview>
      </div>
      <div class="concent">
        <titleview
          title="捐助项目"
          color="#333333"
          background="#E61F26"
          class="concenttitleview"
        ></titleview>
        <div class="inpBox">
          <div class="title">金额：</div>
          <input type="text" placeholder="请输入金额" />
          <div class="company">元</div>
        </div>
        <div class="hr"></div>
        <titleview
          title="确认付款方式"
          color="#333333"
          background="#E61F26"
          class="concenttitleview"
        ></titleview>
        <div class="image">
          <img class="hand" v-show="curr == 0" src="../assets/gernzhifu.png" />
          <img
            @click="tabfun(0)"
            v-show="curr == 1"
            src="../assets/gernzhifu_none.png"
            alt=""
          />
          <img
            v-show="curr == 0"
            class="hand"
            @click="tabfun(1)"
            src="../assets/gongsi.png"
          />
          <img v-show="curr == 1" src="../assets/gongsi_act.png" alt="" />
        </div>
        <div class="inpBox">
          <div class="title">个人名称：</div>
          <input type="text" placeholder="个人名称：" />
        </div>

        <div class="hr"></div>
        <div class="btn hand"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Institutional",

  data: function() {
    return {
      Institutional: "",
      query: "",
      curr: 0
    };
  },
  created() {},
  mounted() {},
  methods: {
    tabfun(e) {
      if (e != this.curr) {
        this.curr = e;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.home {
  width: 100vw;
  min-height: 8rem;
  overflow: hidden;
  position: relative;
  .body {
    width: 11.52rem;
    min-height: 7rem;
    background: #ffffff;
    margin: 2.22rem auto 0;
    overflow: hidden;
    .concent {
      margin-left: 0.8rem;
      margin-top: 0.3rem;
      width: 100%;
      .hr {
        width: 100%;
        height: 0.05rem;
        margin: 0.27rem auto;
        background: #f4f5f9;
      }
      .btn {
        margin-left: 0.83rem;
        width: 1.68rem;
        height: 0.36rem;
        background: url(../assets/xaiyibu.png) no-repeat center / 100% 100%;
      }
      .concenttitleview {
        margin-left: 0.63rem;
      }
      .image {
        margin: 0.35rem auto 0.57rem 0.83rem;
        overflow: hidden;
        img {
          width: 1.23rem;
          height: 1.16rem;
          float: left;
          margin-right: 0.95rem;
          // margin: ;
        }
      }
      .inpBox {
        margin-top: 0.34rem;
        margin-left: 0.82rem;
        overflow: hidden;
        line-height: 0.5rem;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        position: relative;
        .title {
          float: left;
        }
        input {
          background: #ffffff;
          border: 0.01rem solid #dbdbda;
          border-radius: 0.05rem;
          float: left;
          margin: 0;
          padding: 0;
          width: 2.74rem;
          height: 0.5rem;
          padding-left: 0.26rem;
        }
        .company {
          float: left;
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #e61f26;
          margin-left: -0.26rem;
        }
      }
    }
  }
}
</style>
